import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const Login = () => import('./views/Login')
const Board = () => import('./views/Board')
const BasePick = () => import('./components/Chart/OptionView')
export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: { requiresAuth: false }
        },
        {
            path: '/board',
            name: 'board',
            component: Board,
            meta: { requiresAuth: true }
        },
        {
            path: '/BasePick',
            name: 'BasePick',
            component: BasePick,
            meta: { requiresAuth: true }
        },
    ]
})
